import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import api from "@/lib/api";

export default function Footer() {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  return (
    <footer className="bg-msr-ink text-white" data-testid="site-footer">
      <div className="h-1 bg-gradient-to-r from-msr-blue via-msr-green to-msr-blue" />
      <div className="msr-container py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="bg-white inline-flex p-4 mb-5">
            <img src="/brand/msr-logo.png" alt="MSR Business Solutions" className="h-16 w-auto object-contain" />
          </div>
          <p className="text-white/70 leading-relaxed max-w-md">
            {settings?.about_short ||
              "MSR Business Solutions is a Filipino enterprise technology partner helping organizations operate smarter through dependable software, hardware, and infrastructure solutions."}
          </p>
        </div>

        <div>
          <div className="overline text-msr-green-light mb-3">Explore</div>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/solutions" data-testid="footer-solutions-link" className="hover:text-msr-green-light">Solutions</Link></li>
            <li><Link to="/shop" data-testid="footer-shop-link" className="hover:text-msr-green-light">Shop</Link></li>
            <li><Link to="/request-quote" data-testid="footer-rfq-link" className="hover:text-msr-green-light">Request Quote</Link></li>
            <li><Link to="/about" data-testid="footer-about-link" className="hover:text-msr-green-light">About Us</Link></li>
            <li><Link to="/contact" data-testid="footer-contact-link" className="hover:text-msr-green-light">Contact</Link></li>
            <li><Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-msr-green-light">Admin</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline text-msr-green-light mb-3">Get in touch</div>
          <ul className="space-y-2.5 text-sm text-white/80">
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5" />{settings?.address || "Metro Manila, Philippines"}</li>
            <li className="flex items-start gap-2"><Phone size={16} className="mt-0.5" />{settings?.phone || "+63-998-969-3232"}</li>
            <li className="flex items-start gap-2"><Mail size={16} className="mt-0.5" />{settings?.email || "hello@msrbusiness-solutions.com"}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="msr-container py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/60">
          <div>© {new Date().getFullYear()} MSR Business Solutions Corp. All rights reserved.</div>
          <div className="uppercase tracking-[0.18em]">Unlocking New Opportunities</div>
        </div>
      </div>
    </footer>
  );
}
